import { Link } from 'react-router'
import { Square } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { paths } from '@/routes/paths'
import { elapsedMs, formatClock } from './clock'
import { useActiveWork, useTick } from './api'
import { StopWorkPopover } from './StopWorkPopover'

/** The header clock: what you are timing right now, one click from the item and one from Stop. */
export function ActiveWorkChip({ workspaceSlug, enabled }: { workspaceSlug: string; enabled: boolean }) {
  const active = useActiveWork(enabled)
  const data = active.data
  const running = Boolean(data?.session && !data.session.endedAt)
  const now = useTick(running)
  if (!data?.session || !running) return null
  const label = data.card?.code ?? data.card?.title ?? 'Work item'
  return (
    <div className="flex h-9 items-center gap-1 rounded-full border border-border bg-surface pr-1 pl-3 text-xs">
      <span className="relative flex size-2" aria-hidden>
        <span className="absolute inline-flex size-full animate-ping rounded-full bg-ios-green opacity-60 motion-reduce:animate-none" />
        <span className="relative inline-flex size-2 rounded-full bg-ios-green" />
      </span>
      <Link
        to={data.card ? `${paths.work(workspaceSlug)}?card=${data.card.id}` : paths.work(workspaceSlug)}
        className="max-w-40 truncate font-medium text-text-secondary hover:underline"
        title={data.card?.title}
      >
        {label}
      </Link>
      <span className="num font-semibold tabular-nums" role="timer" aria-label="Time on the item you are working on">
        {formatClock(elapsedMs(data.session.startedAt, data.now, data.fetchedAt, now))}
      </span>
      <StopWorkPopover>
        <Button type="button" variant="ghost" size="icon" className="size-7 rounded-full" aria-label="Stop work">
          <Square className="size-3.5" fill="currentColor" />
        </Button>
      </StopWorkPopover>
    </div>
  )
}
